


















































































import Vue from "vue";
import Component from "vue-class-component";
import AddUserDialog from "@/components/layout/dialogs/AddUserDialog.vue";
import AssignTokenDialog from "@/components/layout/dialogs/AssignTokenDialog.vue";
import { IHeaders } from "./interfaces";
import { UserAdmin } from "@/store";
import { IUserProfile } from "@/store/user/models";

@Component({
  components: {
    AddUserDialog,
    AssignTokenDialog,
  },
})
export default class UserTable extends Vue {
  selectedUserId: number = 0;
  selectedUser: any = null;
  dialogDelete: boolean = false;
  loadError: boolean = false;
  activateDialog: boolean = false;
  tokenForm: boolean = false;
  headers: IHeaders[] = [
    { text: "Usuario", align: "start", value: "username" },
    { text: "Nombre", value: "full_name" },
    { text: "Correo electrónico", value: "email" },
    { text: "Tipo de usuario", value: "type" },
    { text: "Token Asignado", value: "token" },
    { text: "Acciones", value: "actions", sortable: false },
  ];

  deleteItem(item: IUserProfile) {
    this.dialogDelete = true;
    this.selectedUserId = item.id;
  }
  deleteItemConfirm() {
    UserAdmin.dispatch("deleteUser", this.selectedUserId).then(() =>
      this.closeDelete()
    );
  }
  //Borra la información del usuario seleccionado
  clearSelectedUser() {
    this.selectedUserId = 0;
    this.selectedUser = null;
    this.activateDialog = false;
  }
  clearTokenDialog() {
    this.tokenForm = false;
    this.clearSelectedUser();
  }
  closeDelete(): void {
    this.selectedUserId = 0;
    this.dialogDelete = false;
  }
  changeToken(item: IUserProfile) {
    this.selectedUserId = item.id;
    this.tokenForm = true;
  }
  changeUser(item: IUserProfile) {
    this.selectedUser = item;
    this.activateDialog = true;
  }
  loadUsers() {
    UserAdmin.dispatch("loadUserList");
  }
  userType(user: IUserProfile) {
    return user.is_admin ? "Administrador" : "Usuario";
  }

  get usersLoaded() {
    return UserAdmin.getters.usersLoaded;
  }

  get userList(): IUserProfile[] {
    return UserAdmin.getters.userList;
  }

  get userData() {
    return this.userList.map((user) => {
      user.type = this.userType(user);
      return user;
    });
  }

  created() {
    this.loadUsers();
  }
}
